import { Attribute } from "./sharedTypes";

/// Attributes travel between pages (and tabs) as a single `search` query param.
/// Kept here so every producer/consumer of that param shares one envelope.
export function encodeAttributesSearchParam(attributes: Attribute[]): string {
  return btoa(encodeURIComponent(JSON.stringify(attributes)));
}

export function decodeAttributesSearchParam(value: string): Attribute[] {
  return JSON.parse(decodeURIComponent(atob(value)));
}
